import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import { InputDateField } from '../../../../utils/InputField';
import { ApiChangeSubsStartDate } from '../SubscriptionsDetailsOpe';

// eslint-disable-next-line no-unused-vars
function SubsStartDateModifyModal({ data, closeModal, handleReload }) {
    const { id, timeSubscriptionStart } = data;
    const { setMessage } = useTemplate();
    const [loading] = useState(false);
    const [formData, setFormData] = useState({
        Id: id,
        SubscriptionStartDate: timeSubscriptionStart
            ? dayjs(timeSubscriptionStart * 1000).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD')
    });

    const handleOnChange = (ev) => {
        const { name, value } = ev.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleOnSubmit = (ev) => {
        ev?.preventDefault();
        ApiChangeSubsStartDate(id, formData)
            .then(({ title }) => {
                closeModal();
                setMessage({ type: 'success', text: title });
                handleReload();
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };

    return (
        <form onSubmit={handleOnSubmit} className="flex flex-col gap-3">
            <InputDateField
                label="Go Live Date"
                name="SubscriptionStartDate"
                formData={formData}
                onChange={handleOnChange}
                required
            />

            <div className="flex justify-end gap-2.5">
                <ButtonCancel title="cancel" onClick={closeModal} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default SubsStartDateModifyModal;
